export default "__VITE_ASSET__HzyZPY4i__"